import axios from 'axios';
import { fmtQuote } from '../common/utils/format';
// import { store } from '../store';

export const getQuote = (quoteId) => {
  const token = window.localStorage.getItem('SessionToken');
  const site = process.env.REACT_APP_HOSTNAME || window.location.hostname;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/quote/${quoteId}/`,
    headers: { Authorization: `Token ${token}` },
    params: { site },
  })
    .then(({ data }) => fmtQuote(data));
};
